import { httpGet, httpPost } from '../../../utils/api.utils';
import { WIRELINE_REQUEST_TYPES_ID as WIRELINEREQUESTIDS, REQUEST_TYPES_ID as REQUESTTYPEIDS } from '../../../constants/external-constants';
import { valueExist } from '../../../utils/helpers.utils';
import { resetWirelineApprover } from './order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer';
import {
    setRequestTypes
    , setTypeOfRequest
    , setIsRequestOnBehalf
    , setRequestOnBehalfData
    , setRequestOnBehalfManagerData
    , setExhibitType
    , setSubscriptionList
    , setPrimarySubscriptionList
    , setEmployeeList
    , setAddressList
    , setGLCodeList
    , setCostCenterList
    , setIsWirelineRequest
    , setUpdateDataList
    , resetRequestData
    , resetSubscriptList
    , setTakeActionCircuitCode
    , setTakeActionSubScriptionDetail 
    , setIsUpdateRequest
    , setIsRequestBehalfToggle
} from '../../../constants/model-reducers/external/request/create-request.settings';

const initialState = {
    requestTypes: {}
    , isWirelineRequest: false
    , isUpdateRequest : false
    , isRequestTypesLoaded: false
    , isRequestOnBehalf: false
    , requestOnBehalfData: {
        EmployeeId: 0
        , Name: ''
        , LastFirstName: ''
        , ContactNumber: ''
        , EmailAddress: ''
        , Country: ''
        , Location: ''
        , LocationSiteCityCountry: ''
        , Vip: 0
    }
    , requestOnBehalfManagerData: {
        UserId: 0
        , email: ''
    }
    , requestTypeId: 0
    , requestType: ""
    , exhibitType: 0
    , subscriptionList: []
    , primarySubscriptionList: []
    , employeeList: []
    , addressList: []
    , glCodeList: []
    , costCenterList: []
    , updateDataList: []
    , takeActionCircuitCode: null
    , takeActionCircuitId: null
    , isRequestOnBehalfToggle: false
};

export const createRequestActions = {
    setIsUpdateRequest: (val) => async (dispatch, state) => {
        dispatch({
            type: setIsUpdateRequest,
            data: val
        });
    },

    setIsRequestBehalfToggle: (val) => async (dispatch, state) => {
        dispatch({
            type: setIsRequestBehalfToggle,
            data: val
        });
    },
    setRequestOnBehalfUser: (val) => async (dispatch, state) => {
        const { selectedItem } = state().requestDetail;
        const { isUpdateRequest } = state().createRequest;
        var canSearchSelf = (isUpdateRequest && (selectedItem?.IsRequestor == false && selectedItem?.IsOwner == true)) ? true : false;

        var res = await httpGet(getROBEmployeeListUrl(val, canSearchSelf, true, state));
        if (val === '') {
            dispatch({ type: setRequestOnBehalfData, data: initialState.requestOnBehalfData });
            dispatch({ type: setRequestOnBehalfManagerData, data: initialState.requestOnBehalfManagerData });
        }
        else {
            var obj = res.find(o => o['LastFirstName'] === val) || res.find(o => o['LastFirstMiddleName'] === val);
            if (obj != null) {
                getManagerDetails(dispatch, obj.EmployeeId);
                dispatch({ type: setRequestOnBehalfData, data: obj });

                sessionStorage.setItem("ROBUserID", obj.UserId);
            }
        }
        dispatch({ type: setIsRequestOnBehalf, data: true });
    },
    setRequestType: (id, type) => (dispatch, state) => {
        dispatch({ type: setTypeOfRequest, id: id, requestType: type });
        dispatch({ type: setIsWirelineRequest, data: valueExist(WIRELINEREQUESTIDS, id) });
    }
    , resetRequestType: () => (dispatch) => {
        dispatch({ type: setTypeOfRequest, id: 0, requestType: '' });
    }
    , setIsRequestOnBehalf: (v, robData) => (dispatch, state) => {
        const { takeActionCircuitCode } = state().createRequest;

        if (!v) {
            dispatch({ type: setRequestOnBehalfData, data: initialState.requestOnBehalfData });
            dispatch({ type: setRequestOnBehalfManagerData, data: initialState.requestOnBehalfManagerData });
        } else {
            if (robData) {
                dispatch({ type: setRequestOnBehalfData, data: robData });
            }
        }

        if (takeActionCircuitCode == null) {
            dispatch({ type: setRequestOnBehalfData, data: initialState.requestOnBehalfData });
        }

        dispatch({ type: setIsRequestOnBehalf, data: v });
    }
    , setTakeActionCircuitCode: (circuitData = null) => (dispatch, state) => {

        if (circuitData != null) {
            dispatch({ type: setTakeActionCircuitCode, data: circuitData.SubscriptionNumber, circuitId: circuitData.CircuitId });
        }
        else {
            const { isWirelineRequest } = state().createRequest;
            const { subscriptionInfo } = state().circuitUsage.circuitData;

            if (isWirelineRequest) {
                if (!subscriptionInfo.HasInProgOrder) {
                    dispatch({ type: setTakeActionCircuitCode, data: subscriptionInfo.SubscriptionNum });
                }
            } else {
                dispatch({ type: setTakeActionCircuitCode, data: subscriptionInfo.SubscriptionNum });
            }
        }
    }
    , setTakeActionSubScriptionDetail: (selectedCircuit) => (dispatch, state) => {
        if (selectedCircuit == null) {
            const { subscriptionInfo } = state().circuitUsage.circuitData;
            if (subscriptionInfo != null && subscriptionInfo !== undefined) {
                let subDetailList = [];
                let subDetail = {
                    CircuitTypeId: subscriptionInfo.CircuitType,
                    CircuitCategoryId: subscriptionInfo.CircuitCategoryModel.CircuitCategoryId,
                    CircuitId: subscriptionInfo.CircuitId,
                    CircuitCode: subscriptionInfo.SubscriptionNum,
                    PlanName: subscriptionInfo.PlanName,
                    SimName: subscriptionInfo.SimType,
                    VendorDetailId: subscriptionInfo.VendorDetailId,
                    VendorName: subscriptionInfo.VendorName,
                    DeviceName: subscriptionInfo.EquipmentModel,
                    CircuitStatus: subscriptionInfo.CircuitStatus,
                    CurrencyName: subscriptionInfo.CurrencyName,
                    DeviceEquipmentId: subscriptionInfo.EquipmentInventoryId
                }
                subDetailList.push(subDetail);
                dispatch({ type: setTakeActionSubScriptionDetail, data: subDetailList });
            } else {
                dispatch({ type: setTakeActionSubScriptionDetail, data: [] });
            }
        }
        else {
            let subDetailList = [];
            let subDetail = {
                CircuitTypeId: selectedCircuit.CircuitTypeID,
                CircuitCategoryId: selectedCircuit.CircuitCategoryID,
                CircuitId: selectedCircuit.CircuitId,
                CircuitCode: selectedCircuit.SubscriptionNumber,
                PlanName: selectedCircuit.PlanName,
                SimName: selectedCircuit.SIMType,
                VendorDetailId: selectedCircuit.VendorID,
                VendorName: selectedCircuit.Vendor,
                DeviceName: selectedCircuit.EquipmentModel,
                CircuitStatus: selectedCircuit.CircuitStatus,
                CurrencyName: selectedCircuit.Currency,
                DeviceEquipmentId: selectedCircuit.EquipmentInventoryID
            }
            subDetailList.push(subDetail);
            dispatch({ type: setTakeActionSubScriptionDetail, data: subDetailList });
        }
    }
    , onRequestOnBehalfUserSelect: (value, propsName, objects) => (dispatch, state) => {

        const { requestOnBehalfData, employeeList } = state().createRequest;

        var obj = employeeList.find(o => o[propsName] === value);
        if (obj != undefined && obj != null && obj.EmployeeId > 0) {
            getManagerDetails(dispatch, obj.EmployeeId);
            dispatch({ type: setRequestOnBehalfData, data: obj });

            sessionStorage.setItem("ROBUserID", obj.UserId);
        } else {
            dispatch({ type: setRequestOnBehalfData, data: initialState.requestOnBehalfData });
            dispatch({ type: setRequestOnBehalfManagerData, data: initialState.requestOnBehalfManagerData });
        }
    }
    , getExhibitType: () => async (dispatch, state) => {
        const { requestTypeId } = state().createRequest;

        var res = await httpGet('external/orderRequest/getRequestFormDisplay?id=' + requestTypeId);

        if (res != null) {
            dispatch({ type: setExhibitType, data: res.exhibit })
        }

        return Promise.resolve(true);
    }
    , fetchCreateRequestItems: (isTakeAction) => async dispatch => {
        isTakeAction = isTakeAction === undefined ? false : isTakeAction;

        dispatch({ type: setRequestTypes, requestTypes: {}, isLoaded: false });

        var requestTypes = await httpGet('external/requestLog/getRequestItems?isTakeAction=' + isTakeAction);

        dispatch({ type: setRequestTypes, requestTypes: requestTypes, isLoaded: true });
        return Promise.resolve(true);
    }
    , fetchSubscriptionByValue: (val, propsName) => async (dispatch, getState) => {
        const { 
            subscriptionList, 
            isWirelineRequest, 
            isRequestOnBehalf, 
            requestOnBehalfData, 
            requestTypeId, 
            takeActionCircuitId 
        } = getState().createRequest;
    
        let obj = null;
        
        if (subscriptionList && subscriptionList.length > 0) {
            if (takeActionCircuitId && requestTypeId === REQUESTTYPEIDS.accessory) {
                obj = subscriptionList.find(o => o[propsName] === val && o['CircuitId'] === takeActionCircuitId);
                dispatch({ type: setSubscriptionList, data: obj });
            } else {
                obj = subscriptionList.find(o => o[propsName] === val);
    
                if (obj) {
                    dispatch({ type: setSubscriptionList, data: [] });
                    return null;
                }
            }
        }
    
        const url = getSubscriptionListUrl(isWirelineRequest);
    
        const empId = isRequestOnBehalf ? requestOnBehalfData.EmployeeId : sessionStorage.EmployeeID;
        let res;
        
        if (isWirelineRequest) {
            res = await httpGet(`${url}${empId}?val=${encodeURIComponent(val)}`);
        } else {
            res = await httpGet(`${url}${empId}/${requestTypeId}?val=${encodeURIComponent(val)}`);
        }
    
        if (res && res.length > 0) {
            dispatch({ type: setSubscriptionList, data: res });
            return res;
        } else {
            dispatch({ type: setSubscriptionList, data: [] });
            return null;
        }
    }
    
    , fetchSubscriptionByCircuitCode: (val, propsName, isRequestOnBehalf ) => async (dispatch, state) => {
        const { subscriptionList, isWirelineRequest, requestTypeId } = state().createRequest;

        if (subscriptionList !== undefined
            && subscriptionList !== null
            && subscriptionList.length > 0) {

            var obj = subscriptionList.find(o => o[propsName] === val);

            if (obj !== undefined) {
                dispatch({ type: setSubscriptionList, data: [] });
                return null;
            }
        }

        let url = getSubscriptionListUrl(isWirelineRequest);

        let empId = isRequestOnBehalf ? isRequestOnBehalf.EmployeeId : sessionStorage.EmployeeID;

        const { approverData, selectedItem } = state().requestDetail;

        if (selectedItem?.IsRequestedInBehalf) {
            empId = approverData.EmployeeId;
        }

        if (isWirelineRequest) {
            var res = await httpGet(url
                + empId + '/'
                + false
                + '?val=' + encodeURIComponent(val));
        } else {
            var res = await httpGet(url
                + empId + '/'
                + requestTypeId
                + '?val=' + encodeURIComponent(val));
        }


        if (res != null && res.length > 0) {
            dispatch({ type: setSubscriptionList, data: res });
            return res;
        } else {
            dispatch({ type: setSubscriptionList, data: [] });
            return null;
        }
    }
    , fetchSubscriptionByRequestDetail: (val, propsName) => async (dispatch, state) => {
        const { subscriptionList, isWirelineRequest, isRequestOnBehalf, requestOnBehalfData, requestTypeId } = state().createRequest;

        if (subscriptionList !== undefined
            && subscriptionList !== null
            && subscriptionList.length > 0) {

            var obj = subscriptionList.find(o => o[propsName] === val);

            if (obj !== undefined) {
                dispatch({ type: setSubscriptionList, data: [] });
                return null;
            }
        }

        let url = getSubscriptionListUrl(isWirelineRequest);

        const { approverData, selectedItem, requestData } = state().requestDetail;

        let empId = (requestData.RequestedInBeHalfOf !== undefined && requestData.RequestedInBeHalfOf !== null && requestData.RequestedInBeHalfOf.EmployeeId > 0) ? requestData.RequestedInBeHalfOf.EmployeeId : sessionStorage.EmployeeID;

        if (requestData?.Order?.IsRequestedInBehalf) {
            empId = approverData.EmployeeId;
        }

        if (isWirelineRequest) {
            var res = await httpGet(url
                + empId
                + '?val=' + encodeURIComponent(val));
        } else {
            var res = await httpGet(url
                + empId + '/'
                + requestTypeId
                + '?val=' + encodeURIComponent(val));
        }


        if (res != null && res.length > 0) {
            dispatch({ type: setSubscriptionList, data: res });
            return res;
        } else {
            dispatch({ type: setSubscriptionList, data: [] });
            return null;
        }
    }
    , fetchPrimarySubscriptionByValue: (val, propsName) => async (dispatch, state) => {

        const { primarySubscriptionList, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        if (primarySubscriptionList !== undefined
            && primarySubscriptionList !== null
            && primarySubscriptionList.length > 0) {

            var obj = primarySubscriptionList.find(o => o[propsName] === val);

            if (obj !== undefined) {
                dispatch({ type: setPrimarySubscriptionList, data: [] });
                return null;
            }
        }

        let url = getPrimarySubscriptionListUrl();

        let empId = isRequestOnBehalf ? requestOnBehalfData.EmployeeId : sessionStorage.EmployeeID;

        var res = await httpGet(url
            + empId
            + '?val=' + encodeURIComponent(val));

        if (res != null && res.length > 0) {
            dispatch({ type: setPrimarySubscriptionList, data: res });
            return res;
        } else {
            dispatch({ type: setPrimarySubscriptionList, data: [] });
            return null;
        }
    }
    , fetchROBEmployeeByValue: (val, propsName) => async (dispatch, state) => {

        const { employeeList, isUpdateRequest } = state().createRequest;
        const { selectedItem } = state().requestDetail;
        var canSearchSelf = (isUpdateRequest && (selectedItem?.IsRequestor == false && selectedItem?.IsOwner == true)) ? true : false;

        if (employeeList !== undefined
            && employeeList !== null
            && employeeList.length > 0) {

            var obj = employeeList.find(o => o[propsName] === val);

            if (obj !== undefined) {
                dispatch({ type: setEmployeeList, data: [] });
                return null;
            }
        }

        var res = await httpGet(getROBEmployeeListUrl(val, canSearchSelf, true, state));

        if (res != null && res.length > 0) {
            dispatch({ type: setEmployeeList, data: res });
            return res;
        } else {
            dispatch({ type: setEmployeeList, data: [] });
            return null;
        }
    }
    , fetchEmployeeByValue: (val, propsName) => async (dispatch, state) => {

        const { employeeList, isWirelineRequest, isRequestOnBehalf } = state().createRequest;

        if (employeeList !== undefined
            && employeeList !== null
            && employeeList.length > 0) {

            var obj = employeeList.find(o => o[propsName] === val);

            if (obj !== undefined) {
                dispatch({ type: setEmployeeList, data: [] });
                return null;
            }
        }

        var canSearchSelf = isRequestOnBehalf ? true : false;
        var res = await httpGet(getROBEmployeeListUrl(val, canSearchSelf, false, state));

        if (res != null && res.length > 0) {
            dispatch({ type: setEmployeeList, data: res });
            return res;
        } else {
            dispatch({ type: setEmployeeList, data: [] });
            return null;
        }
    }
    , fetchAddressByValue: (val, propsName) => async (dispatch, state) => {

        const { addressList, isWirelineRequest, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        if (addressList !== undefined
            && addressList !== null
            && addressList.length > 0) {

            var obj = addressList.find(o => o[propsName] === val);

            if (obj !== undefined) {
                dispatch({ type: setAddressList, data: [] });
                return null;
            }
        }

        let url = "";

        if (isWirelineRequest) {
            //let empId = isRequestOnBehalf ? requestOnBehalfData.EmployeeId : sessionStorage.EmployeeID;
            url = 'external/autosuggest/getAllLocationsSuggestions/'
                + sessionStorage.EmployeeID + '/'
                + val;
        }

        var res = await httpGet(url);

        if (res != null && res.length > 0) {
            dispatch({ type: setAddressList, data: res });
            return res;
        } else {
            dispatch({ type: setAddressList, data: [] });
            return null;
        }
    }
    , fetchGLCodeByValue: (val, propsName) => async (dispatch, state) => {

        const { glCodeList, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        if (glCodeList !== undefined
            && glCodeList !== null
            && glCodeList.length > 0) {

            var obj = glCodeList.find(o => o[propsName] === val);

            if (obj !== undefined) {
                dispatch({ type: setGLCodeList, data: [] });
                return null;
            }
        }

        let url = getGLCodeListUrl();

        //let empId = isRequestOnBehalf ? requestOnBehalfData.EmployeeId : sessionStorage.EmployeeID;

        var res = await httpGet(url
            + sessionStorage.EmployeeID
            + '?val=' + encodeURIComponent(val));

        if (res != null && res.length > 0) {
            dispatch({ type: setGLCodeList, data: res });
            return res;
        } else {
            dispatch({ type: setGLCodeList, data: [] });
            return null;
        }
    }
    , fetchCostCenterByValue: (val, propsName) => async (dispatch, state) => {

        const { costCenterList, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        if (costCenterList !== undefined
            && costCenterList !== null
            && costCenterList.length > 0) {

            var obj = costCenterList.find(o => o[propsName] === val);

            if (obj !== undefined) {
                dispatch({ type: setCostCenterList, data: [] });
                return null;
            }
        }

        let url = getCostCenterListUrl();

        //let empId = isRequestOnBehalf ? requestOnBehalfData.EmployeeId : sessionStorage.EmployeeID;

        var res = await httpGet(url
            + sessionStorage.EmployeeID
            + '?val=' + encodeURIComponent(val));

        if (res != null && res.length > 0) {
            dispatch({ type: setCostCenterList, data: res });
            return res;
        } else {
            dispatch({ type: setCostCenterList, data: [] });
            return null;
        }
    }
    , resetRequestData: () => async (dispatch) => {
        resetRequest(dispatch);
        dispatch(resetWirelineApprover());    
    }
    ,
    resetSubscriptList: () => async (dispatch) => {
        dispatch({ type: setSubscriptionList, data: []});
    }
}

function resetRequest(dispatch) {
    dispatch({ type: resetRequestData, data: initialState });
    dispatch({ type: setTakeActionCircuitCode, data: null });
    dispatch({ type: setTakeActionSubScriptionDetail, data: null });
    dispatch({ type: setSubscriptionList, data: []});
    dispatch({ type: setEmployeeList, data: [] });
}

//function getAddressListUrl(isWireline, val) {
//    if (isWireline) {
//        return 'external/autosuggest/getAllLocationsSuggestions/'
//            + userDataConst.employeeID + '/'
//            + val;
//    }
//}

function getROBEmployeeListUrl(val, canSearchSelf, isRequestOnBehalf, state) {

    const { requestTypeId, requestOnBehalfData } = state()?.createRequest;

    var empIdRob = requestOnBehalfData.EmployeeId

    return 'external/autosuggest/getEmployees/'
        + sessionStorage.EmployeeID + '/'
        + sessionStorage.UserRoleID + '/'
        + sessionStorage.IsExecutive + '/'
        + sessionStorage.IsKeyUser + '/'
        + val + '/'
        + isRequestOnBehalf + '/'
        + requestTypeId + '/'
        + empIdRob + '/'
        + canSearchSelf
}

function getEmployeeListUrl(isWireline, val, state) {

    const { isRequestOnBehalf, requestTypeId } = state().createRequest;

    if (isWireline) {
            return 'external/autosuggest/getWireLineApprover/'
                + sessionStorage.EmployeeID + '/'
                + sessionStorage.UserRoleID + '/'
                + sessionStorage.IsExecutive + '/'
                + sessionStorage.IsKeyUser + '/'
                + val;
    } else {
    if (isRequestOnBehalf) {
            return 'external/changeUser/searchEmployeesDetails/'
                + sessionStorage.UserID + '/'
                + sessionStorage.UserRoleID + '/'
                + sessionStorage.IsKeyUser + '/'
                + sessionStorage.IsExecutive + '/'
                + isRequestOnBehalf + '/'
                + val + '/'
                + sessionStorage.ROBUserID + '/'
                + requestTypeId;

    } else {
            return 'external/changeUser/searchEmployeesDetails/'
                + sessionStorage.UserID + '/'
                + sessionStorage.UserRoleID + '/'
                + sessionStorage.IsKeyUser + '/'
                + sessionStorage.IsExecutive + '/'
                + isRequestOnBehalf + '/'
                + val + '/'
                + 0 + '/';
        }
    }
}

function getSubscriptionListUrl(isWireline) {

    if (isWireline) {
        return 'external/autosuggest/getAllWirelineSubscriptionSuggestions/';
    } else {
        return 'external/autosuggest/getAllDeviceSubscriptionSuggestions/';
    }
}
function getPrimarySubscriptionListUrl() {
    return 'external/autosuggest/getAllPrimaryCircuitsSuggestions/';
}
function getGLCodeListUrl() {
    return 'external/autosuggest/getGLCodeDetails/';
}
function getCostCenterListUrl() {
    return 'external/autosuggest/getCostCenterDetails/';
}

async function getManagerDetails(dispatch, id) {

    var res = await httpGet('internal/administration/getEmployeeDetails?id=' + id);

    if (res != null) {
        dispatch({ type: setRequestOnBehalfManagerData, data: res });
    } else {
        dispatch({ type: setRequestOnBehalfManagerData, data: initialState.requestOnBehalfManagerData });
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setIsUpdateRequest:
            return {
                ...state,
                isUpdateRequest: action.data
            };
        case setTypeOfRequest:
            return {
                ...state,
                requestTypeId: action.id
                , requestType: action.requestType
            };
        case setRequestTypes:
            return {
                ...state,
                requestTypes: action.requestTypes
                , isRequestTypesLoaded: action.isLoaded
            };
        case setIsRequestOnBehalf:
            return {
                ...state,
                isRequestOnBehalf: action.data
            };
        case setRequestOnBehalfData:
            return {
                ...state,
                requestOnBehalfData: action.data
            };
        case setRequestOnBehalfManagerData:
            return {
                ...state,
                requestOnBehalfManagerData: action.data
            };
        case setExhibitType:
            return {
                ...state,
                exhibitType: action.data
            };
        case setIsWirelineRequest:
            return {
                ...state,
                isWirelineRequest: action.data
            };
        case setIsUpdateRequest:
            return {
                ...state,
                isUpdateRequest: action.data
            };
        case setUpdateDataList:
            return {
                ...state,
                updateDataList: action.data
            };
        case setSubscriptionList:
            return {
                ...state,
                subscriptionList: action.data
            };
        case setPrimarySubscriptionList:
            return {
                ...state,
                primarySubscriptionList: action.data
            };
        case setEmployeeList:
            return {
                ...state,
                employeeList: action.data
            };
        case setAddressList:
            return {
                ...state,
                addressList: action.data
            };
        case setGLCodeList:
            return {
                ...state,
                glCodeList: action.data
            };
        case setCostCenterList:
            return {
                ...state,
                costCenterList: action.data
            };
        case resetRequestData:
            return {
                ...state
                , isWirelineRequest: action.data.isWirelineRequest
                , requestTypeId: action.data.requestTypeId
                , requestType: action.data.requestType
                , subscriptionList: action.data.subscriptionList
                , isUpdateRequest: action.data.isUpdateRequest
            };
        case setTakeActionCircuitCode:
            return {
                ...state,
                takeActionCircuitCode: action.data,
                takeActionCircuitId: action.circuitId,
            };
        case setTakeActionSubScriptionDetail:
            return {
                ...state,
                takeActionSubScriptionDetail: action.data
            };
        case setIsRequestBehalfToggle:
            return {
                ...state,
                isRequestOnBehalfToggle: action.data
            }
        default: return state;
    }
}


